import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PatientSearchSelect = ({ token, onSelect, testId = 'patient-search' }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedName, setSelectedName] = useState(null);

  useEffect(() => {
    if (query.trim().length < 2 || query === selectedName) {
      setResults([]);
      return;
    }
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/patients/paginated`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search: query.trim(), page_size: 20 }
        });
        setResults(data.items);
        setOpen(true);
      } catch (error) {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [query, token, selectedName]);

  const choose = (patient) => {
    setSelectedName(patient.full_name);
    setQuery(patient.full_name);
    setOpen(false);
    onSelect(patient);
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input
        value={query}
        onChange={(e) => { setSelectedName(null); setQuery(e.target.value); setOpen(true); }}
        placeholder="Escriba nombre o teléfono (mín. 2 letras)..."
        className="pl-9"
        data-testid={`${testId}-input`}
      />
      {open && query.trim().length >= 2 && (
        <div className="absolute z-50 mt-1 w-full max-h-60 overflow-y-auto rounded-md border bg-white shadow-lg" data-testid={`${testId}-results`}>
          {loading && <p className="px-3 py-2 text-sm text-slate-400">Buscando...</p>}
          {!loading && results.length === 0 && <p className="px-3 py-2 text-sm text-slate-400">Sin resultados</p>}
          {!loading && results.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => choose(p)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50 transition-colors"
              data-testid={`${testId}-option-${p.id}`}
            >
              <span className="font-medium text-slate-800">{p.full_name}</span>
              <span className="text-slate-500"> · {p.phone}{p.codigo_paciente ? ` · ${p.codigo_paciente}` : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
